var WIDTH = $(window).width();

function getHeaderPosition() {
  function headerPosition() {
    var headerBlock = $('.header');
    var headerOffset = headerBlock.offset().top;
    (headerOffset > 50) ? headerBlock.addClass('scrolled') : headerBlock.removeClass('scrolled');
  }
  headerPosition();
  $(window).scroll(headerPosition);
}

function mainMenu() {
  var neededTabindex = $('[tabindex]:not(#mainMenu [tabindex])');

  function openMenu() {
    $('#mainMenu').fadeIn(100);
    neededTabindex.each(function() {
      $(this).attr('tabindex', -1);
    });
    setTimeout(function() {
      $('#mainMenu, #boxShadow').addClass('open');
      $('html, body').addClass('overflow');
    } ,200)
  }
  function closeMenu() {
    $('#mainMenu, #boxShadow').removeClass('open');
    $('html, body').removeClass('overflow');
    neededTabindex.each(function() {
      $(this).attr('tabindex', 1);
    });
    setTimeout(function() {
      $('#mainMenu').fadeOut(100);
    }, 500)
    if(WIDTH < 667) {
      $('.main-menu__top-info').removeClass('show_form');
      $('.form__fields').fadeOut(100);
    }
  }
  function outerClose(e) {
    if($('#boxShadow').is(e.target) && $('#mainMenu').hasClass('open')) {
      closeMenu();
    }
  }
  function enterOpen(e) {
    var key = e.which;
    if(key == 13) {
      openMenu();
      return false;
    }
  }
  function enterClose(e) {
    var key = e.which;
    if(key == 13) {
      closeMenu();
      return false;
    }
  }

  $(document).on('click', '#mainMenuBtn', openMenu);
  $(document).on('keypress', '#mainMenuBtn', enterOpen);
  $(document).on('click', '#mainMenuCloseBtn', closeMenu);
  $(document).on('keypress', '#mainMenuCloseBtn', enterClose);
  $(document).on('click', outerClose);
}

function footerDesc() {
  var descBtn = $('#footerMoreBtn');
  var descBlock = $('#footerMoreDesc');

  (function() {
    descBtn.addClass('show_info');
    descBlock.addClass('show_info');
    descBlock.slideDown(300);
  })();

  function openBlock() {
    descBtn.addClass('show_info');
    descBlock.addClass('show_info');
    descBlock.slideDown(300);
    $('html, body').animate({
      scrollTop: descBlock.offset().top - 80
    }, 1000);
  }

  function closeBlock() {
    descBtn.removeClass('show_info');
    descBlock.removeClass('show_info');
    descBlock.slideUp(300);
  }

  function openCloseDesc() {
    if(descBlock.hasClass('show_info')) {
      closeBlock();
    } else {
      openBlock();
    }
  }

  $(document).on('click', '#footerMoreBtn', openCloseDesc);
}

function menuFindForm() {
  var findForm = $('#mainMenuFindForm');
  findForm[0].reset();

  function showClearBtn() {
    findForm.addClass('focused');
  }
  function hideClearBtn() {
    var findField = $(this);
    if(findField.val() === '') {
      findForm.removeClass('focused');
    }
  }
  function showFormMobile(e) {
    if(WIDTH < 667 && !$('.main-menu__top-info').hasClass('show_form')) {
      e.preventDefault();
      $('.main-menu__top-info').addClass('show_form');
      $('.form__fields').delay(300).fadeIn(300);
    }
  }

  $(document).on('focus', '#mainMenuFindForm .form__field', showClearBtn);
  $(document).on('blur', '#mainMenuFindForm .form__field', hideClearBtn);
  $(document).on('click', '#mainMenuFindForm .clean__btn', hideClearBtn);
  $(document).on('click', '#mainMenuFindForm .form__btn', showFormMobile);
}

function loginForm() {
  function openForm(elem) {
    elem.find('#mainLoginFormBtn').attr('aria-label', 'פתח את טופס הכניסה');
    elem.addClass('open');
    elem.closest('.main-login').addClass('open_form');
    elem.find('.main-login__form').slideDown(300);
    elem.find('.main-login__join').slideDown(300);
  }
  function closeForm() {
    var formWrapper = $('#mainLoginFormBtn').closest('.main-login__form-wrapper');
    formWrapper.find('#mainLoginFormBtn').attr('aria-label', 'טופס כניסה סגור');
    formWrapper.removeClass('open');
    formWrapper.closest('.main-login').removeClass('open_form');
    $('.main-login__join').slideUp(300);
    $('.main-login__form').slideUp(300);
  }
  function openCloseForm() {
    var formWrapper = $(this).closest('.main-login__form-wrapper');
    if(formWrapper.hasClass('open')) {
      closeForm();
    } else {
      openForm(formWrapper);
    }
  }

  function enterOpenCloseForm(e) {
    e.preventDefault();
    var key = e.which;
    var formWrapper = $(this).closest('.main-login__form-wrapper');
    if(formWrapper.hasClass('open') && key == 13) {
      closeForm();
    } else {
      openForm(formWrapper);
    }
  }

  $(document).on('click', '#mainLoginFormBtn', openCloseForm);
  $(document).on('keypress', '#mainLoginFormBtn', enterOpenCloseForm);
}

function inputFocusAnimation() {

  function initAppointmentSelect(id) {
    function addFocusesClass(elem) {
      elem.closest('.inp').addClass('focused');
      elem.closest('.inp').removeClass('has_text');
    }
    function addAllClasses(elem) {
      elem.closest('.inp').addClass('focused');
      elem.closest('.inp').addClass('has_text');
    }
    function removeAllClasses(elem) {
      elem.closest('.inp').removeClass('focused');
      elem.closest('.inp').removeClass('has_text');
    }
    $(id).selectize({
      onFocus: function () {
        var selectWrapper = $(this)[0].$control;
        addFocusesClass(selectWrapper);
      },
      onBlur: function() {
        var selectWrapper = $(this)[0].$control;
        var selectVal = $(this)[0].$input.find('option').val();
        (!selectVal) ? removeAllClasses(selectWrapper) : addAllClasses(selectWrapper);
      },
      onChange: function(value) {
        var selectWrapper = $(this)[0].$control;
        (!value.length) ? addFocusesClass(selectWrapper) : addAllClasses(selectWrapper);
      },
    });
  }
  initAppointmentSelect('#innerSelect');
  initAppointmentSelect('#appointmentMeetingPeriod');
  initAppointmentSelect('#appointmentMeetingTheme');
  initAppointmentSelect('#appointmentMeetingDate');
  initAppointmentSelect('#contactBranch');
  initAppointmentSelect('#contactTheme');
  initAppointmentSelect('#openingAccountPreferBranch');
  initAppointmentSelect('#filterReportType');
  initAppointmentSelect('#filterReportYear');
  initAppointmentSelect('#filterReportQuarterly');
  initAppointmentSelect('#calculatorLoanTypeMob');

  function checkDisabledInput() {
    var inputField = $('.inp__field');
    inputField.each(function() {
      if($(this).prop('disabled')) {
        $(this).closest('.inp').addClass('disabled');
        $(this).closest('.inp').removeClass('focused');
        $(this).closest('.inp').removeClass('has_text');
      }
    });
  }
  checkDisabledInput();

  function moveUpLabel() {
    var field = $(this);
    field.closest('.inp').addClass('focused');
    field.closest('.inp').removeClass('has_text');
  }

  function moveDownLabel() {
    var field = $(this);
    if(!field.val()) {
      field.closest('.inp').removeClass('focused');
      field.closest('.inp').removeClass('has_text');
    } else {
      field.closest('.inp').addClass('has_text');
    }
  }

  $(document).on('focus', '.inp__field, input[type=select-one]', moveUpLabel);
  $(document).on('blur', '.inp__field, input[type=select-one]', moveDownLabel);
}

function mainGallery() {

  (function() {
    var firstBlock = $('#mainGallery > div:first-child');
    openBlock(firstBlock);
  })();

  function closeBlock() {
    $('#mainGallery > div .block__content-text').clearQueue().finish();
    $('#mainGallery > div .block__more').clearQueue().finish();

    $('.block__content-text').slideUp(200);
    $('.block__more').fadeOut(200);

    if($('#mainGallery > div').is(':focus')) {
      $('#mainGallery > div').removeClass('selected focus_open');
    } else {
      $('#mainGallery > div').removeClass('selected');
    }
  }

  function openBlock(elem) {
    var block = elem,
        blockText = block.find('.block__content-text'),
        blockMoreBtn = block.find('.block__more');
    
    const openPromise = new Promise(function(resolve) {

      if(block.is(':focus')) {
        block.addClass('selected focus_open');
      } else {
        block.addClass('selected');
      }

      resolve('true');
    });

    openPromise.then(function(resolve){
        blockText.delay(500).slideDown(300);
        blockMoreBtn.delay(500).fadeIn(300);
        resolve('true');
    });
  }

  function focusOpenCloseBlock() {
    var block = $(this);

    if(!block.hasClass('focus_open') && !block.hasClass('selected')) {
      closeBlock();
      openBlock(block);
    }
  }

  $(document).on({mouseenter: function() {closeBlock(); openBlock($(this));}, mouseleave: closeBlock}, '#mainGallery > div');
  $(document).on('focus', '#mainGallery > div', focusOpenCloseBlock)
}

function careerPopup() {
  var neededTabindex = $('[tabindex]:not(.popup-career [tabindex])');

  function openPopup() {
    $('html, body').addClass('overflow');
    $('#boxShadow').addClass('open');
    $('.popup-career').fadeIn(300);
    $('.popup-career').find('#popupClose').focus();

    neededTabindex.each(function() {
      $(this).attr('tabindex', -1);
    });
  }

  function closePopup() {
    $('html, body').removeClass('overflow');
    $('#boxShadow').removeClass('open');
    $('.popup-career').fadeOut(300);

    neededTabindex.each(function() {
      $(this).attr('tabindex', 1);
    });
  }

  function outerClose(e) {
    if($('#boxShadow').is(e.target) && $('.popup-career').length) {
      closePopup();
    }
  }

  $(document).on('click', '.popup', openPopup);
  $(document).on('click', '#popupClose', closePopup);
  $(document).on('click', outerClose);
}

function cutText() {
  var textWrapper = $('#innerSeventhText');
  var text = textWrapper.find('p');
  var oldText = text.text();
  var cutedText;

  if(text.text().length > 500) {
    cutedText = text.text().substring(0, 500)
    text.text(cutedText);
    textWrapper.append('<a href="javascript:void(0);" class="read_more">קרא עוד…</a>')
  }

  function showText() {
    textWrapper.addClass('open');
    text.text(oldText);
    $('.read_more').text('הסתר טקסט');
  }

  function hideText() {
    $('html,body').animate({
      scrollTop: textWrapper.offset().top - 100
    }, 300);

    setTimeout(function() {
      textWrapper.removeClass('open');
      text.text(cutedText);
      $('.read_more').text('קרא עוד');
    }, 400)
  }

  function showHideText() {
    if(textWrapper.hasClass('open')) {
      hideText();
    } else {
      showText();
    }
  }

  $(document).on('click', '.read_more', showHideText);
}

function removeFields() {
  if($('.form__types').length) {
    $('.form__types').remove();
  }
}

function triggerEnterClick() {
  function triggerClick(e) {
    var key = e.which;
    if(key == 13) {
      $(this).click();
      return false;
    }
  }
  $(document).on('keypress', '.inp.inp_file, .form__types-list > li > .list__radio', triggerClick);
}

function setStandartArrAttr() {
  var sliderArrs = $('.slick-arrow');
  if(sliderArrs.length) sliderArrs.attr('tabindex', 1);
}

$(document).ready(function() {
  getHeaderPosition();
  mainMenu();
  footerDesc();
  menuFindForm();
  loginForm();
  inputFocusAnimation();
  careerPopup();
  triggerEnterClick();
  setStandartArrAttr();
  if(WIDTH > 667 && $('#mainGallery').length) {
    mainGallery();
  }
  if(WIDTH < 667) {
    cutText();
    removeFields();
  }
});
